// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * UpdateNotification Styles
 *
 * Modern, non-intrusive notification banner for application updates.
 * Uses gradient background, smooth animations, and responsive design.
 */

.update-notification {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  max-width: 600px;
  width: 90%;
  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: auto;
}

/* Slide down animation */
@keyframes slideDown {
  from {
    transform: translate(-50%, -120px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.update-notification__content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 18px 24px;
  border-radius: 16px;
  box-shadow:
    0 10px 40px rgba(0, 0, 0, 0.2),
    0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.update-notification__icon {
  font-size: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.update-notification__text {
  flex: 1;
  min-width: 0;
}

.update-notification__title {
  display: block;
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.update-notification__description {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.95;
  font-weight: 400;
}

.update-notification__current-version {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.8;
  font-weight: 500;
}

.update-notification__actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.update-notification__button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  font-family: inherit;
}

.update-notification__button:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.update-notification__button:active {
  transform: translateY(1px);
}

.update-notification__button--primary {
  background: white;
  color: #667eea;
}

.update-notification__button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 255, 255, 0.3);
}

.update-notification__button--secondary {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  backdrop-filter: blur(10px);
}

.update-notification__button--secondary:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Responsive design for mobile */
@media (max-width: 640px) {
  .update-notification {
    top: 10px;
    width: 95%;
  }

  .update-notification__content {
    padding: 14px 16px;
    gap: 12px;
  }

  .update-notification__icon {
    font-size: 24px;
  }

  .update-notification__title {
    font-size: 14px;
  }

  .update-notification__description {
    font-size: 13px;
  }

  .update-notification__current-version {
    font-size: 11px;
  }

  .update-notification__actions {
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }

  .update-notification__button {
    width: 100%;
    padding: 8px 16px;
    font-size: 13px;
  }
}

/* Very small screens */
@media (max-width: 400px) {
  .update-notification__content {
    flex-direction: column;
    text-align: center;
  }

  .update-notification__icon {
    margin: 0 auto;
  }

  .update-notification__actions {
    width: 100%;
  }
}

/* Accessibility: Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .update-notification {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .update-notification__icon {
    animation: none;
  }

  .update-notification__button {
    transition: none;
  }
}

/* Dark mode support (if your app has dark mode) */
@media (prefers-color-scheme: dark) {
  .update-notification__content {
    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .update-notification__button--primary {
    background: #e2e8f0;
    color: #2d3748;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateNotification/UpdateNotification.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,uDAAuD;EACvD,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE;IACE,kCAAkC;IAClC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB;;gCAE8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,6DAA6D;IAC7D,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":["/**\n * UpdateNotification Styles\n *\n * Modern, non-intrusive notification banner for application updates.\n * Uses gradient background, smooth animations, and responsive design.\n */\n\n.update-notification {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  max-width: 600px;\n  width: 90%;\n  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  pointer-events: auto;\n}\n\n/* Slide down animation */\n@keyframes slideDown {\n  from {\n    transform: translate(-50%, -120px);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n.update-notification__content {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 18px 24px;\n  border-radius: 16px;\n  box-shadow:\n    0 10px 40px rgba(0, 0, 0, 0.2),\n    0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.update-notification__icon {\n  font-size: 32px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.update-notification__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.update-notification__title {\n  display: block;\n  margin: 0 0 6px 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.update-notification__description {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  opacity: 0.95;\n  font-weight: 400;\n}\n\n.update-notification__current-version {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  opacity: 0.8;\n  font-weight: 500;\n}\n\n.update-notification__actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.update-notification__button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.update-notification__button:focus {\n  outline: 2px solid rgba(255, 255, 255, 0.5);\n  outline-offset: 2px;\n}\n\n.update-notification__button:active {\n  transform: translateY(1px);\n}\n\n.update-notification__button--primary {\n  background: white;\n  color: #667eea;\n}\n\n.update-notification__button--primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 255, 255, 0.3);\n}\n\n.update-notification__button--secondary {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  backdrop-filter: blur(10px);\n}\n\n.update-notification__button--secondary:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* Responsive design for mobile */\n@media (max-width: 640px) {\n  .update-notification {\n    top: 10px;\n    width: 95%;\n  }\n\n  .update-notification__content {\n    padding: 14px 16px;\n    gap: 12px;\n  }\n\n  .update-notification__icon {\n    font-size: 24px;\n  }\n\n  .update-notification__title {\n    font-size: 14px;\n  }\n\n  .update-notification__description {\n    font-size: 13px;\n  }\n\n  .update-notification__current-version {\n    font-size: 11px;\n  }\n\n  .update-notification__actions {\n    flex-direction: column;\n    gap: 6px;\n    width: 100%;\n  }\n\n  .update-notification__button {\n    width: 100%;\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 400px) {\n  .update-notification__content {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .update-notification__icon {\n    margin: 0 auto;\n  }\n\n  .update-notification__actions {\n    width: 100%;\n  }\n}\n\n/* Accessibility: Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .update-notification {\n    animation: fadeIn 0.3s ease-in;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .update-notification__icon {\n    animation: none;\n  }\n\n  .update-notification__button {\n    transition: none;\n  }\n}\n\n/* Dark mode support (if your app has dark mode) */\n@media (prefers-color-scheme: dark) {\n  .update-notification__content {\n    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  .update-notification__button--primary {\n    background: #e2e8f0;\n    color: #2d3748;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
